module.exports = __webpack_public_path__ + "static/img/publish.6d03f63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/publish.png?v=20201104
// module id = wgyV
// module chunks = 1